<div>
    <div class="container-fluid fixed-top">
      <app-header></app-header>
    </div>

    <div class="container-fluid fruite py-5">
        <div class="container py-5">
            <h1 class="mb-4">Tienda Acozam</h1>
            <div class="row g-4">
                <div class="col-lg-12">
                    <div class="row g-4">
                        <div class="col-xl-3">
                            <div class="input-group w-100 mx-auto d-flex">
                                <input type="search" class="form-control p-3" placeholder="Nombre del producto"
                                     aria-describedby="search-icon-1"
                                     (blur)="searchProducts($event)" />
                                <span id="search-icon-1" class="input-group-text p-3"><i class="fa fa-search"></i></span>
                            </div>
                        </div>
                        <!-- <div class="col-6"></div>
                        <div class="col-xl-3">
                            <div class="bg-light ps-3 py-3 rounded d-flex justify-content-between mb-4">
                                <label for="fruits">Default Sorting:</label>
                                <select id="fruits" name="fruitlist" class="border-0 form-select-sm bg-light me-3" form="fruitform">
                                  <option value="volvo">Nothing</option>
                                  <option value="saab">Popularity</option>
                                  <option value="opel">Organic</option>
                                  <option value="audi">Fantastic</option>
                                </select>
                            </div>
                        </div> -->
                    </div>
                    <div class="row g-4">
                        <div class="col-lg-3">
                            <div class="row g-4">
                                <app-catalogs-selector [catalogs]="catalogs" (getCategory)="getcategory($event)">
                                </app-catalogs-selector>
                                <!-- <div class="col-lg-12">
                                    <div class="mb-3">
                                        <h4 class="mb-2">Price</h4>
                                        <input type="range" class="form-range w-100" id="rangeInput" name="rangeInput" min="0" max="500" value="0" oninput="amount.value=rangeInput.value">
                                        <output id="amount" name="amount" min-velue="0" max-value="500" for="rangeInput">0</output>
                                    </div>
                                </div> -->
                                <app-offers-info [numSlides]="1" [title]="'Promociones'"></app-offers-info>
                            </div>
                        </div>
                        <div class="col-lg-9">
                            <div class="row g-4 justify-content-center">
                                @if(products.length > 0) { @for(product of products; track product) {
                                <div class="col-md-6 col-lg-6 col-xl-4">
                                    <app-product-card [product]="product"></app-product-card>

                                </div>
                                } } @else {
                                <div class="text-center px-4 w-100">
                                    <h2>No se encontraron productos.</h2>

                                </div>
                                }



                                <div class="col-md-6 col-lg-6 col-xl-4">
                                </div>

                                <!-- <div class="col-12">
                                    <div class="pagination d-flex justify-content-center mt-5">
                                        <a href="#" class="rounded">&laquo;</a>
                                        <a href="#" class="active rounded">1</a>
                                        <a href="#" class="rounded">2</a>
                                        <a href="#" class="rounded">3</a>
                                        <a href="#" class="rounded">4</a>
                                        <a href="#" class="rounded">5</a>
                                        <a href="#" class="rounded">6</a>
                                        <a href="#" class="rounded">&raquo;</a>
                                    </div>
                                </div> -->
                                <div class="col-12 w-100">
                                    <app-related-product [title]="'Otros Productos'"></app-related-product>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Fruits Shop End-->

    <div>
        <app-footer></app-footer>
    </div>